var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{attrs:{"id":_vm.id,"src":_vm.url,"controls":"","autoplay":"","muted":"","webkit-playsinline":""},domProps:{"muted":true}})}
var staticRenderFns = []

export { render, staticRenderFns }